import { render, staticRenderFns } from "./PortalBreadcumb.vue?vue&type=template&id=99e7b6ba&scoped=true&"
import script from "./PortalBreadcumb.vue?vue&type=script&lang=js&"
export * from "./PortalBreadcumb.vue?vue&type=script&lang=js&"
import style0 from "./PortalBreadcumb.vue?vue&type=style&index=0&id=99e7b6ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e7b6ba",
  null
  
)

export default component.exports